"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flowmeterSchema = exports.flowmeterInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
exports.flowmeterInitialized = {
    name: '',
    description: '',
    flowCategory: '',
    mlPerCircleNormal: 0,
    mlPerCircle: 0,
    spinsPerLiter: 0,
    mlPerCircleToUse: 0,
};
exports.flowmeterSchema = joi_1.default.object({
    name: joi_1.default.string().optional().allow('').max(50).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name', isRequired: true }),
    }),
    description: joi_1.default.string().optional().allow('').max(400).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Description' }),
    }),
    flowCategory: joi_1.default.string().optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Flow category' }),
    }),
    spinsPerLiter: joi_1.default.number().min(0).max(100000).optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml per circle' }),
    }),
    mlPerCircleNormal: joi_1.default.number().min(0).max(100000).optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml per circle normally' }),
    }),
    mlPerCircle: joi_1.default.number().min(0).max(9999).optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml per circle' }),
    }),
    mlPerCircleToUse: joi_1.default.number().min(0).max(9999).optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Ml per circle to use' }),
    })
});
